<div class="publication-import">
	<h2>{{ 'IMPORT_FROM_PUBLICATION' | translate }}</h2>
	<bb-filters [filterConfig]="filterConfig" [currentPath]="path" [search]="search" [lightBackground]="lightBackground"></bb-filters>

	<bb-table-container>
		<bb-table-header>
			<bb-table-header-cell class="column-mediatype" property="mediatype">&nbsp;</bb-table-header-cell>
			<bb-table-header-cell class="column-id" property="id">{{ 'ID' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="column-publicationname" property="publicationName">{{ 'PUBLICATION' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="column-cliptitle" property="clipTitle">{{ 'TITLE' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="column-length" property="length">{{ 'LENGTH' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="column-views" property="views">{{ 'VIEWS' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="column-statusicon" property="status"></bb-table-header-cell>
			<bb-table-header-cell class="column-created date" property="createddate">{{ 'CREATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="column-updated date" property="updateddate">{{ 'UPDATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="buttons"></bb-table-header-cell>
		</bb-table-header>

		<bb-table-row *ngFor="let row of rows" [row]="row">
			<bb-table-cell property="mediatype"><div [innerHtml]="row?.data?.mediatype | mediatypeIcon"></div></bb-table-cell>
			<bb-table-cell property="id">{{ row?.data?.id }}</bb-table-cell>
			<bb-table-cell property="publicationName">{{ sharingPublications[row?.data?.publicationid] }}</bb-table-cell>
			<bb-table-cell property="clipTitle" class="overflow"><div [innerHTML]="row?.data | clipTitle"></div>
			</bb-table-cell>
			<bb-table-cell property="length">{{ row?.data?.length | seconds }}</bb-table-cell>
			<bb-table-cell property="views">{{ row?.data?.views }}</bb-table-cell>
			<bb-table-cell property="status"><div [innerHTML]="row?.data | statusIcon"></div></bb-table-cell>
			<bb-table-cell property="createddate" class="date" [titleValue]="row?.data?.createddate | bbDate">{{ row?.data?.createddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell property="updateddate" class="date" [titleValue]="row?.data?.updateddate | bbDate">{{ row?.data?.updateddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell class="buttons">
				<a class="button" *ngIf="!row.data.childid && (importing.indexOf(row.data.id) === -1)" [ngClass]="{'disabled': !putRight}" (click)="importMediaclip(row)">
					<i class="fa fa-level-down"></i><span>{{ 'IMPORT' | translate }}</span>
				</a>
				<a class="button" *ngIf="importing.indexOf(row.data.id) !== -1">
					<i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i><span>{{ 'IMPORTING' | translate }}</span>
				</a>
				<a class="button" *ngIf="imported.indexOf(row.data.id) !== -1 || row.data.childid" [routerLink]="['/library/mediaclip/', row.data.childid, 'metadata']">
					<i class="fa fa-edit"></i><span>{{ 'IMPORTED' | translate }}</span>
				</a>
			</bb-table-cell>
		</bb-table-row>
	</bb-table-container>

	<div class="no-results" *ngIf="rows && !rows.length">{{ 'NO_MEDIA_CLIPS_FOUND' | translate }}</div>

	<bb-table-pager></bb-table-pager>
</div>
